import toast from "react-hot-toast";
import useApi from "../useApi";

interface IUpdatePhoneCallStatusReq {
  status: "yes" | "no";
  patientId?: string;
}

interface IUpdatePhoneCallStatusRes {
  status: string;
  message: string;
}

const useUpdatePhoneCallStatus = () => {
  const { loading, makeApiCall } = useApi({
    method: "PATCH",
    url: "",
  });

  const updatePhoneCallStatus = async (
    patientId: string,
    data: { status: "yes" | "no" },
  ) => {
    const { response, error } = await makeApiCall<
      { status: "yes" | "no" },
      IUpdatePhoneCallStatusRes
    >(data, `/rtm/billing-cycle/phone-call-status?patientId=${patientId}`);

    if (response?.status === "success") {
      toast.success(response.message);
      return response;
    }

    if (error) {
      toast.error(error.msg);
    }
  };

  return {
    updatePhoneCallStatus,
    loading,
  };
};

export default useUpdatePhoneCallStatus;
